import { ErrorType } from '../errors-handler/ErrorsHandler.types';
import { isNewVersionAvailableError } from './new-version-available-error/NewVersionAvailableError.utils';
import { isNoAvailableSpaceError } from './no-available-space-error/NoAvailableSpaceError.utils';
import { isOfflineError } from './offline-error/OfflineError.utils';

export const extractErrorEventInfo = (event: ErrorType['event']) => {
  let message: string = '';
  let src: string | null = null;

  if (event) {
    if ('message' in event && typeof event?.message === 'string') {
      message = event?.message;
    } else if ('reason' in event) {
      if (typeof event?.reason === 'string') {
        message = event?.reason;
      } else if (
        typeof event?.reason === 'object' &&
        event?.reason &&
        'message' in event?.reason &&
        typeof event?.reason?.message === 'string'
      ) {
        message = event?.reason?.message;
      }
    }

    if (
      'target' in event &&
      event?.target &&
      'getAttribute' in event?.target &&
      typeof event?.target?.getAttribute === 'function'
    ) {
      src = event?.target?.getAttribute('src');
    }
  }

  return {
    message,
    src,
  };
};

export const isViewableError = (error?: ErrorType) => {
  return error && (isOfflineError(error) || isNoAvailableSpaceError(error) || isNewVersionAvailableError(error));
};
